<template>
  <div class="outcome-list">
    <div v-for="row in sortedRows" :key="row.reason" class="outcome-row">
      <span class="outcome-reason">{{ labelFn(row.reason) }}</span>
      <div class="outcome-track">
        <div
          v-if="row.approved"
          class="outcome-seg approved"
          :style="{ width: pct(row.approved, maxTotal) + '%' }"
          :title="`Godkända: ${row.approved}`"
        ></div>
        <div
          v-if="row.rejected"
          class="outcome-seg rejected"
          :style="{ width: pct(row.rejected, maxTotal) + '%' }"
          :title="`Avslagna: ${row.rejected}`"
        ></div>
        <div
          v-if="otherCount(row)"
          class="outcome-seg other"
          :style="{ width: pct(otherCount(row), maxTotal) + '%' }"
          :title="`Övrigt: ${otherCount(row)}`"
        ></div>
      </div>
      <span class="outcome-total">{{ row.total }}</span>
    </div>
    <div class="outcome-legend">
      <span class="outcome-legend-item"
        ><span class="outcome-dot approved"></span> Godkända</span
      >
      <span class="outcome-legend-item"
        ><span class="outcome-dot rejected"></span> Avslagna</span
      >
      <span class="outcome-legend-item"
        ><span class="outcome-dot other"></span> Övrigt</span
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    rows: {
      type: Array,
      default: () => []
    },
    labelFn: {
      type: Function,
      default: r => r || 'Ej angivet'
    }
  },
  computed: {
    sortedRows() {
      return [...this.rows].sort((a, b) => (b.total || 0) - (a.total || 0));
    },
    maxTotal() {
      return Math.max(...this.rows.map(r => r.total || 0), 1);
    }
  },
  methods: {
    otherCount(row) {
      return Math.max(
        0,
        (row.total || 0) - (row.approved || 0) - (row.rejected || 0)
      );
    },
    pct(value, max) {
      if (!max) return 0;
      return Math.round((value / max) * 100);
    }
  }
};
</script>
<style scoped>
.outcome-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.outcome-row {
  display: grid;
  grid-template-columns: 180px 1fr 60px;
  align-items: center;
  gap: 12px;
}

.outcome-reason {
  font-size: 1.2rem;
  color: #5a6370;
  text-align: right;
}

.outcome-track {
  display: flex;
  height: 24px;
  background: #f0f0f2;
  border-radius: 4px;
  overflow: hidden;
}

.outcome-seg {
  height: 100%;
  transition: width 0.5s ease;
}

.outcome-dot.approved,
.outcome-seg.approved {
  background: #339d64;
}

.outcome-dot.rejected,
.outcome-seg.rejected {
  background: #ff3843;
}

.outcome-dot.other,
.outcome-seg.other {
  background: #878b9d;
}

.outcome-total {
  font-size: 1.2rem;
  font-weight: 700;
  color: #2c3e50;
}

.outcome-legend {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 8px;
}

.outcome-legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 1.1rem;
  color: #878b9d;
}

.outcome-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
</style>
